import React, { MouseEvent, useRef, useState } from 'react';
import { KibEditIcon, KibAddFillIcon } from '@chewy/kib-icons-react';
import { KibSpinner } from '@chewy/kib-interstitials-react';
import { useMutation } from 'react-query';
import ImageUpload from '../../image-upload/ImageUpload';
import { usePetForm } from '../../pet-form/PetFormContext/PetFormContext';

import './editImage.scss';
import { uploadImage } from '../../../api/petApi';
import isFormattedImage from '../../../util/isFormattedImage';
import getImageUrl from '../../../util/getImageUrl';
import { isClient } from '../../../util/helpers';

const EditImage = () => {
  const [isImageLoading, setIsImageLoading] = useState(isClient());
  const { formValues, setFormValues, setFormValue } = usePetForm();

  const mutation = useMutation(uploadImage, {
    onSuccess: (data) => {
      setFormValues({
        ...formValues,
        bannerUrl: data,
        image: data,
      });
      setIsImageLoading(true);
    },
  });

  const uploadButtonRef = useRef<HTMLButtonElement>(null);
  const onCompleteCrop = (result: Blob) => {
    mutation.mutate({ body: result });
  };
  const onRemove = () => {
    setFormValue('image', '');
  };

  const getImage = (image: string) =>
    isFormattedImage(image)
      ? image.replace(/_SS150_/, '_SX630_')
      : getImageUrl(image, 630, 'AC_SX');

  const onUploadClick = (event: MouseEvent) => {
    event.preventDefault();
    uploadButtonRef.current?.click();
  };
  return (
    <div className="edit-image kib-margin__top">
      {isImageLoading && formValues.image && !mutation.isLoading ? <KibSpinner /> : null}
      {mutation.isLoading ? (
        <KibSpinner data-testid="edit-image-loader" />
      ) : (
        <ImageUpload
          onCompleteCrop={onCompleteCrop}
          aspectRatio="16:7"
          circleCrop={false}
          title="Upload Profile Image"
        >
          <button
            className="edit-image__cover"
            ref={uploadButtonRef}
            data-testid="edit-form-banner-image-btn"
            aria-label="Edit Cover Photo"
          >
            {formValues.image && (
              <>
                <KibEditIcon
                  className="edit-image__cover__icon"
                  role="img"
                  focusable="false"
                  aria-label="Edit Cover Photo"
                />
                <img
                  src={getImage(formValues.image)}
                  alt={formValues.name}
                  className="edit-image__cover__image"
                  onLoad={() => {
                    setIsImageLoading(false);
                  }}
                />
              </>
            )}
          </button>
        </ImageUpload>
      )}
      {formValues.image ? (
        <button
          onClick={onRemove}
          type="button"
          className="edit-image__button edit-image__button--remove-cover-photo kib-margin__bottom--huge kib-margin__top--large"
          data-testid="edit-form-remove-banner-image-btn"
        >
          Remove Cover Photo
        </button>
      ) : (
        <button
          className="edit-image__button edit-image__button--add-cover-photo kib-margin__bottom"
          onClick={onUploadClick}
          data-testid="edit-form-upload-banner-image-btn"
        >
          <span className="edit-image__button__icon">
            <KibAddFillIcon />
          </span>
          Add a Cover Photo
        </button>
      )}
    </div>
  );
};

export default EditImage;
